import { signJwt } from '../jwt';
import { compress } from './compress';
import { ISession } from './types';

export const encrypt = async (payload: ISession) => {
  const compressedPayload = await compress(payload);
  return signJwt(compressedPayload);
};
